import {
    TooltipContent
} from 'shared/components/ui/tooltip';

/**
 * @component
 * @param {Object} props
 * @param {*} props.icon The icon before the text
 * @param {string} props.tooltipText The message/text
 * @returns
 */
export default function KBTooltipContent({
    icon, tooltipText
}) {
    return (
        <>
            <TooltipContent
                side="bottom"
                className="bg-background max-w-[40vw] block font-normal border-border border p-3 text-foreground shadow-xl text-sm"
            >
                <div className="flex items-start text-wrap w-full gap-2">
                    {icon && <div className="mt-0.5">{icon}</div>}
                    <div className="w-full space-y-2 font-normal">{tooltipText}</div>
                </div>
            </TooltipContent>
        </>
    );
}